import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Button,
  Paper,
  Grid,
  TextField,
  FormControl,
} from "@mui/material";
import { paperStyles, loginStyles } from './styles.js';
import { BUTTONS } from '../../shared/constants';
import { changePasswordUser } from './logic.js';
import AlertDialog from '../alert-dialog';
import LoadingButton from '@mui/lab/LoadingButton';


const UpdatePassword = () => {
  const [password, setPassword] = useState(null);
  const [passwordConfirmation, setPasswordConfirmation] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [countdown, setCountdown] = useState(null);
  const [loading, setLoading] = useState(false);
  const { key } = useParams();

  useEffect(() => {
    if (countdown === null) return;

    if (countdown === 0) {
      window.location.href = "/";
      return;
    }

    const timer = setTimeout(() => {
      const el = document.getElementById("countdown-value");
      if (el) el.innerText = countdown - 1;
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);



  const showButton = () => {
    return password && passwordConfirmation && password === passwordConfirmation;
  };

  return (
    <Grid>
      {open && (
        <AlertDialog
          handleClickOpen={() => setOpen(true)}
          handleClose={() => setOpen(false)}
          showAcceptButton={false}
          dialogContentText={message}
          dialogTitle="Confirmación"
          open={open}
        />
      )}
      <Paper elevation={10} style={paperStyles} >
        <FormControl fullWidth margin="dense">
          <img src="../Images/Logo_Tu_Experiencia_Talma_fondo_azul.png" alt="logo" style={loginStyles} />
          <TextField
            label="Nueva clave"
            placeholder="Nueva clave"
            value={password || ''}
            type='password'
            onChange={e => setPassword(e.target.value)}
            fullWidth
            required />
          <p />
         <TextField
            label="Confirmar clave"
            placeholder="Confirmar clave"
            value={passwordConfirmation || ''}
            type='password'
            onChange={e => setPasswordConfirmation(e.target.value)}
            fullWidth
            required
            error={passwordConfirmation !== null && password !== passwordConfirmation}
            helperText={
              passwordConfirmation !== null && password !== passwordConfirmation
                ? "Las contraseñas no coinciden"
                : ""
            }
          />

          <p />
         <LoadingButton
            fullWidth
            loading={loading}
            color="primary"
            variant="contained"
            disabled={!showButton()}
            onClick={async () => {
              setLoading(true);
              await changePasswordUser(
                password,
                setMessage,
                setOpen,
                key,
                setCountdown
              );
              setLoading(false);
            }}
          >
            {BUTTONS.CHANGE_PASSWORD_USER}
          </LoadingButton>

        </FormControl>
      </Paper>
    </Grid>
  );
};

export default UpdatePassword;
